import Data from './Data';

const HeroHeadingSidebar = (props) => {
  return <Data {...props} />;
};

export default HeroHeadingSidebar;
